"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
export default function GalerAAntesYDespuS() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const rituals = [{
    label: "Densidad Capilar",
    caption: "Tratamiento regenerativo"
  }, {
    label: "Fortalecimiento",
    caption: "Nutrición profunda"
  }, {
    label: "Control de Caída",
    caption: "Protocolo médico"
  }];
  const plates = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_densidad_capilar.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_densidad_capilar.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_densidad_capilar.png-wvc-sizes",
    alt: "Resultado de tratamiento de densidad capilar",
    caption: "CASO 01 / RECUPERACIÓN",
    ratio: 4 / 5,
    wrapper: "col-span-7 md:col-start-1 md:col-end-6 md:row-start-1 md:row-end-3 z-10"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_fortalecimiento.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_fortalecimiento.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_fortalecimiento.png-wvc-sizes",
    alt: "Detalle de fortalecimiento capilar",
    caption: "CASO 02 / VITALIDAD",
    ratio: 1,
    wrapper: "col-span-5 md:col-start-4 md:col-end-7 md:row-start-3 md:row-end-4 -mt-10 md:-mt-12 z-20 relative"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_control_caida.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_control_caida.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/paciente_control_caida.png-wvc-sizes",
    alt: "Resultado de control de caída",
    caption: "CASO 03 / PRECISIÓN",
    ratio: 3 / 4,
    wrapper: "col-span-7 md:col-start-6 md:col-end-9 md:row-start-2 md:row-end-4 md:mt-20 z-10"
  }];
  return;
}
function CoordinateTicks({
  color
}: {
  color: string;
}) {
  const tick = "absolute w-2 h-2 before:content-[''] before:absolute before:inset-0 before:m-auto before:w-2 before:h-px after:content-[''] after:absolute after:inset-0 after:m-auto after:w-px after:h-2";
  return <>
      <span aria-hidden="true" className={`${tick} -top-1 -left-1`} style={{
      color
    }}>
        <span className="absolute inset-0 m-auto w-2 h-px" style={{
        backgroundColor: color
      }} />
        <span className="absolute inset-0 m-auto w-px h-2" style={{
        backgroundColor: color
      }} />
      </span>
      <span aria-hidden="true" className={`${tick} -top-1 -right-1`} style={{
      color
    }}>
        <span className="absolute inset-0 m-auto w-2 h-px" style={{
        backgroundColor: color
      }} />
        <span className="absolute inset-0 m-auto w-px h-2" style={{
        backgroundColor: color
      }} />
      </span>
      <span aria-hidden="true" className={`${tick} -bottom-1 -left-1`} style={{
      color
    }}>
        <span className="absolute inset-0 m-auto w-2 h-px" style={{
        backgroundColor: color
      }} />
        <span className="absolute inset-0 m-auto w-px h-2" style={{
        backgroundColor: color
      }} />
      </span>
      <span aria-hidden="true" className={`${tick} -bottom-1 -right-1`} style={{
      color
    }}>
        <span className="absolute inset-0 m-auto w-2 h-px" style={{
        backgroundColor: color
      }} />
        <span className="absolute inset-0 m-auto w-px h-2" style={{
        backgroundColor: color
      }} />
      </span>
    </>;
}